import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';
import { companiesQueryKeys } from '@/modules/companies/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type UpdateCompanyRequestBody = ApiRequestBody<typeof endpoints.company, 'put'>;

export const useUpdateCompanyMutation = () => {
  return useMutation({
    mutationFn: async ({
      id,
      ...body
    }: { id: string } & UpdateCompanyRequestBody) => {
      const { data } = await fetchClient.PUT(endpoints.company, {
        params: { path: { id } },
        body,
      });
      return data;
    },
    onSettled: (_result, _error, variables) => {
      invalidateQuery(companiesQueryKeys.detail(variables.id))();
      invalidateQuery(companiesQueryKeys.list())();
    },
  });
};
